import { connect } from 'react-redux';

import {
  getFieldPathsFor,
  getUnits,
  getEventNames,
  getMyPermissions,
  getFunnels,
  getSortedTemplates,
} from '../../../../reducers/analyticsApp';
import UnitBuilderCreateHeader from '../../../../components/dashboards/cards/builder/UnitBuilderCreateHeader';
import { toggleDashboardTemplate } from '../../../../actions/dashboards/templates';
import {
  setDashboardUnitType,
  deleteDashboardUnit,
  changeSizeDashboardUnit,
  setDashboardUnitName,
  setMetaInfForRevenue,
} from '../../../../actions/dashboards/dashboards';
import { startUpdateFunnel } from '../../../../actions/dashboards/funnels';
import { commonEvents } from '../../../../constants/event';

const mapStateToProps = (state) => {
  const funnels = getFunnels(state);

  return {
    templates: getSortedTemplates(state),
    funnels,
    paths: getFieldPathsFor(state, commonEvents.PAYMENT),
    quantityUnits: getUnits(state).length,
    events: getEventNames(state),
    permissions: getMyPermissions(state),
  };
};

const mapDispatchToProps = {
  setUnitType: (id, type) => setDashboardUnitType(id, type),
  setMetaInfForRevenue: (unitId, paths) => setMetaInfForRevenue(unitId, paths),
  deleteUnit: (id) => deleteDashboardUnit(id),
  changeSizeUnit: (unitId) => changeSizeDashboardUnit(unitId),
  onToggleTemplate: (template, unitId) => toggleDashboardTemplate(template, unitId),
  onChangeUnitName: (unitId, unitName) => setDashboardUnitName(unitId, unitName),
  startUpdateFunnel: (funnel, unitId) => startUpdateFunnel(funnel, unitId),
};

export default connect(mapStateToProps, mapDispatchToProps)(UnitBuilderCreateHeader);
